import React, { useEffect, useState, useMemo } from "react"
import Modal from '../index'
import Input from '../../Form/Input'
import FormGroup from "../../Form/FormGroup"
import Button from "../../Form/Button"
import FormGroupInline from '../../Form/FormGroupInline'
import { MdLockOutline, MdOutlineContactPage, MdOutlineVpnKey } from "react-icons/md"
import { toast } from "react-toastify"
import Select from "../../Form/Select"
import { sortValuesByPropertyAndDirection } from "../../../utils/utils"
import styles from "./modalStartChat.module.css"

const ModalStartChat = ({ value = {}, inboxes = [], contacts = [], restrictedAccess = null, onSubmit = () => { }, onRequestAccess = () => { }, onClearRestrictedAccess = () => { }, closeModal = () => { } }) => {
    const [contact, setContact] = useState(value)

    const listContacts = useMemo(() => {
        return [...(contacts || [])]
            .sort((a, b) => sortValuesByPropertyAndDirection(a, b, "name"))
            .map(contact => {
                const name = `${contact.name} ${!contact.is_group && contact?.number ? `(${contact?.number})` : ''}`
                return {
                    id: contact._id,
                    value: name
                }
            })
    }, [contacts])

    useEffect(() => {
        if (contact?.phone && contact?.contact_id !== undefined) {
            handleChangeValue("contact_id", undefined)
        }
    }, [contact?.phone])

    const handleChangeValue = (name, value) => {
        onClearRestrictedAccess()
        setContact(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    const handleSave = (e) => {
        e.preventDefault()
        if (contact.inbox_id && (contact.contact_id || contact.phone)) {
            onSubmit(contact)
        } else {
            toast.error("Preencha todos os campos para prosseguir!")
        }
    }

    return (
        <Modal
            icon={<MdOutlineContactPage />}
            title={"Iniciar Conversa"}
            description={"Preencha os campos abaixo e clique em iniciar"}
            closeModal={closeModal}
        >
            <form onSubmit={handleSave}>
                {!value?.contact_id && !contact?.contact_id &&
                    <FormGroup labelText="Celular">
                        <Input type="phone" placeholder="+55 99 9 9999-9999" value={contact?.phone ?? ""} onChange={(e) => handleChangeValue("phone", e.target.value)} disabled={value?.contact_id ? true : false} />
                    </FormGroup>
                }
                {!value?.contact_id && !value?.phone && !contact?.phone && listContacts?.length > 0 &&
                    < FormGroup labelText="Contatos">
                        <Select name="Selecione uma opção..." placeholder="Buscar uma caixa de entrada" multiple={false} options={listContacts} selected={contact?.contact_id ?? ""} onChange={(value) => handleChangeValue("contact_id", value)} />
                    </FormGroup>
                }
                <FormGroup labelText="Caixa de Entrada">
                    <Select name="Selecione uma opção..." placeholder="Buscar uma caixa de entrada" multiple={false} options={inboxes} selected={contact?.inbox_id ?? ""} onChange={(value) => handleChangeValue("inbox_id", value)} />
                </FormGroup>
                {restrictedAccess?.conversation_id &&
                    <div className={styles.restrictedAccess}>
                        <div className={styles.restrictedIcon}>
                            <MdLockOutline />
                        </div>
                        <div className={styles.restrictedContent}>
                            <strong>Conversa existente com outro responsável</strong>
                            <span>
                                Essa conversa já existe, mas você ainda não tem acesso. Solicite liberação para que o responsável ou gestor aprove sua entrada.
                                {restrictedAccess?.access_request_status === "pending" ? " Sua solicitação já foi enviada e está aguardando aprovação." : ""}
                            </span>
                            <Button variant="secondary"
                                type="button"
                                disabled={restrictedAccess?.access_request_status === "pending"}
                                onClick={onRequestAccess}
                            >
                                <MdOutlineVpnKey /> {restrictedAccess?.access_request_status === "pending" ? "Solicitação enviada" : "Solicitar acesso"}
                            </Button>
                        </div>
                    </div>
                }
                <FormGroupInline>
                    <Button variant='primary' type="submit">Iniciar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal >
    )
}

export default ModalStartChat
